var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUrgentAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#FF3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8375 7.878V11.882C13.8375 12.3067 13.8165 12.7243 13.7745 13.135C13.7325 13.541 13.6765 13.9727 13.6065 14.43H12.4375C12.3675 13.9727 12.3115 13.541 12.2695 13.135C12.2275 12.7243 12.2065 12.3067 12.2065 11.882V7.878H13.8375ZM11.9405 17.048C11.9405 16.9033 11.9662 16.7657 12.0175 16.635C12.0735 16.5043 12.1482 16.3923 12.2415 16.299C12.3395 16.2057 12.4539 16.131 12.5845 16.075C12.7152 16.019 12.8552 15.991 13.0045 15.991C13.1492 15.991 13.2869 16.019 13.4175 16.075C13.5482 16.131 13.6602 16.2057 13.7535 16.299C13.8469 16.3923 13.9215 16.5043 13.9775 16.635C14.0335 16.7657 14.0615 16.9033 14.0615 17.048C14.0615 17.1973 14.0335 17.3373 13.9775 17.468C13.9215 17.594 13.8469 17.7037 13.7535 17.797C13.6602 17.8903 13.5482 17.9627 13.4175 18.014C13.2869 18.07 13.1492 18.098 13.0045 18.098C12.8552 18.098 12.7152 18.07 12.5845 18.014C12.4539 17.9627 12.3395 17.8903 12.2415 17.797C12.1482 17.7037 12.0735 17.594 12.0175 17.468C11.9662 17.3373 11.9405 17.1973 11.9405 17.048Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUrgentAction);
export default __webpack_public_path__ + "static/media/urgentAction.04d7e392cb3e4c8103da58a7869f6c77.svg";
export { ForwardRef as ReactComponent };